export const blockIconsAudioandvideoSkipNext = (
	<span className='material-symbols-outlined'>skip_next</span>
);
